import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from './authentication/guards/authentication.guard';
import { NoAuthGuard } from './authentication/guards/no-auth.guard';

const routes: Routes = [
  {
    path: 'login',
    canActivate: [NoAuthGuard],
    loadComponent: () =>
      import('./authentication/login/login.component').then(
        (module) => module.LoginComponent,
      ),
  },
  {
    path: 'forgot-password',
    canActivate: [NoAuthGuard],
    loadComponent: () =>
      import('./authentication/forgot-password/forgot-password.component').then(
        (module) => module.ForgotPasswordComponent,
      ),
  },
  {
    path: 'reset-password',
    canActivate: [NoAuthGuard],
    loadComponent: () =>
      import('./authentication/reset-password/reset-password.component').then(
        (module) => module.ResetPasswordComponent,
      ),
  },
  {
    path: 'activate',
    canActivate: [NoAuthGuard],
    loadComponent: () =>
      import('./authentication/complete-password/complete-password.component').then(
        (module) => module.CompletePasswordComponent,
      ),
  },
  {
    path: '',
    canActivate: [AuthenticationGuard],
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
